import { TextInputWithInfoTooltip } from "pages/Products/ProductPage/TextInputWithInfoTooltip"
import React from "react"
import { Box } from "@strapi/design-system"

interface BrandSelectProps {
  value?: string
  onChange: (value: string) => void
  description?: string
  label: string
  errors?: string[]
}

export const BrandSelect: React.FC<BrandSelectProps> = ({
  value,
  onChange,
  description,
  label,
  errors,
}) => {
  return (
    <Box>
      <TextInputWithInfoTooltip
        label={label}
        errors={errors}
        name="brand"
        value={value}
        description={description}
        onChange={(e) => onChange(e.target.value)}
      />
    </Box>
  )
}
